import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class ContratoService {
  static async getByCompanyId(companyId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/contratos`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: { companyId }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getById(id) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/contratos/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getAll() {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/contratos`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async create(data) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${adminUrl}/contratos/create`, { data }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Error desconocido';
      console.error('[ContratoService.create]', message, err.response?.data);
      return {
        status: 'error',
        message,
        code: err.response?.data?.code,
        existingCodigo: err.response?.data?.existingCodigo
      };
    }
  }

  static async update(id, data) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.put(`${adminUrl}/contratos/${id}`, { data }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Error desconocido';
      console.error('[ContratoService.update]', message, err.response?.data);
      return {
        status: 'error',
        message,
        code: err.response?.data?.code,
        existingCodigo: err.response?.data?.existingCodigo
      };
    }
  }

  /**
   * Renueva un contrato: crea el sucesor clonando sus condiciones y cierra el
   * original como renovado. El cuerpo puede ir vacío — por defecto el término
   * nuevo continúa donde terminaba el anterior.
   * @param {string} id - Contrato a renovar.
   * @param {{startDate?: string, endDate?: string, reason?: string}} [payload]
   * @returns {Promise<{status: string, data?: object, message?: string}>}
   */
  static async renew(id, payload = {}) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(
        `${adminUrl}/contratos/${id}/renew`,
        payload,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.error?.message || null
      };
    }
  }

  /**
   * Historial de cambios de estado de un contrato, del más antiguo al más nuevo.
   * @param {string} id - Contrato.
   * @returns {Promise<{status: string, data?: Array}>}
   */
  static async getStatusHistory(id) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(
        `${adminUrl}/contratos/${id}/status-history`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async delete(id) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.delete(`${adminUrl}/contratos/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok' };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
